import { parseJSON } from '@gem/utils';

import { logger } from '../../logger';
import { RestClient } from '../RestClient/RestClient';

export function addRestClientLogger(client: RestClient): void {
  const loggerWorkspace = logger.get('RestClient');

  client.addRequestInterceptor((options, requestName) => {
    loggerWorkspace.log(
      `%c${requestName}%c -> Request`,
      'color: #5698d6; font-size: 1em; font-weight: bold;',
      'color: #bf912c',
      options
    );
    return options;
  });

  client.addResponseInterceptor(
    (response, requestName) => {
      loggerWorkspace.log(
        `%c${requestName}%c -> Response`,
        'color: #5698d6; font-size: 1em; font-weight: bold;',
        'color: #30964b',
        response.data
      );
      return response.data;
    },
    (error, requestName) => {
      const errorResponse = parseJSON(error?.responseData || '');
      loggerWorkspace.log(
        `%c${requestName}%c -> Response`,
        'color: #5698d6; font-size: 1em; font-weight: bold;',
        'color: #a83b3d',
        error.name,
        error.statusCode,
        error.message,
        errorResponse,
        error
      );

      return error;
    }
  );
}
